import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { User } from '../../users/users.model';
import { UserService } from '../../users/users.service';

export interface DialogAssistedBidAssignData {
  lotId: string;
  racketName: string;
  bidValue: number;
}

@Component({
  selector: 'app-dialog-assisted-bid-assign',
  templateUrl: './dialog-assisted-bid-assign.component.html',
  styleUrls: ['./dialog-assisted-bid-assign.component.scss'],
})
export class DialogAssistedBidAssignComponent implements OnInit, OnDestroy {
  readonly searchControl = new FormControl('');
  filteredUsers: User[] = [];
  selectedUser: User | null = null;
  isSearching = false;

  private readonly destroy$ = new Subject<void>();

  constructor(
    public readonly dialogRef: MatDialogRef<DialogAssistedBidAssignComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: DialogAssistedBidAssignData,
    private readonly userService: UserService,
  ) {}

  ngOnInit(): void {
    this.searchControl.valueChanges
      .pipe(debounceTime(300), takeUntil(this.destroy$))
      .subscribe((term) => this.onSearchInput(term));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onUserSelected(user: User): void {
    this.selectedUser = user;
    this.searchControl.setValue('', { emitEvent: false });
    this.filteredUsers = [];
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (this.selectedUser) {
      this.dialogRef.close(this.selectedUser);
    }
  }

  displayUser(user: User): string {
    return user ? `${user.client} - ${user.username}` : '';
  }

  private onSearchInput(term: string | User): void {
    if (typeof term !== 'string' || !term || term.trim().length < 2) {
      this.filteredUsers = [];
      return;
    }

    this.isSearching = true;
    this.userService
      .getAllUsers(term.trim(), 'H', undefined, 30)
      .then((users) => {
        this.filteredUsers = users;
      })
      .catch(() => {
        this.filteredUsers = [];
      })
      .finally(() => {
        this.isSearching = false;
      });
  }
}
